import * as z from "zod";
import { defineIntegrationSettings } from "../define-settings";

export const wayfairSettings = defineIntegrationSettings({
  fields: { clientId: z.string().trim().min(1, "Client ID is required") },
  secrets: {
    clientSecret: z.string().trim().min(1, "Client Secret is required"),
  },
  connectOnly: {},
  computed: {},
});
